import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { MarketingCampaignsHistoryService } from '../../../../services/marketing-campaigns/marketing-campaigns-history.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CampaignTypeStatus } from '../../../../interfaces/campaigns/campaign.interface';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MarketingCampaignsService } from 'src/app/services/marketing-campaigns/marketing-campaigns.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';

@Component({
  selector: 'app-marketing-campaigns-history',
  templateUrl: './marketing-campaigns-history.component.html',
  styleUrls: ['./marketing-campaigns-history.component.scss']
})
export class MarketingCampaignsHistoryComponent implements OnInit {
  @ViewChild(PaginatorComponent) paginator!: PaginatorComponent;

  public reload = false;
  public page = 1;
  public limit = 50;
  public filter = '';
  public status = 'all';
  public campaignId = 'all';
  public itemCount = 0;

  columnNames = ['campaignName', 'target', 'channel', 'date', 'status'];
  tableDataSource = new MatTableDataSource<any>();

  filterValues = Object.values(CampaignTypeStatus);
  campaigns: { id: string, name: string }[] = [];
  searchForm: FormControl = new FormControl('');

  constructor(
    private marketingCampaignsHistoryService: MarketingCampaignsHistoryService,
    private campaignService: MarketingCampaignsService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public utilService: UtilsService
  ) {
  }

  async ngOnInit(): Promise<void> {
    await this.loadCampains();
    this.load();
    this.searchForm.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((value: string) => {
      this.filter = value;
      this.load();
      this.paginator.resetFirstPage();
    });
  }

  load(): void {
    const params = {
      page: this.page,
      limit: this.limit,
      filter: this.filter,
      status: this.status,
      campaignId: this.campaignId
    }

    this.marketingCampaignsHistoryService.getAll(params).then(response => {
      this.itemCount = response.count;
      this.tableDataSource.data = response.history.map(history => {
        const campaign = this.campaigns.find(campaign => campaign.id === history.campaignId);
        return {
          campaign: { name: campaign?.name, id: campaign?.id },
          target: history.to,
          channel: 'email',
          date: new Date(history.createdAt),
          status: history.status
        }
      });
    });
  }

  async loadCampains(): Promise<void> {
    await this.campaignService.getAll().then(campaigns => {
      this.campaigns = campaigns.map(campaign => ({ id: campaign.id, name: campaign.name }));
    });
  }

  setStatusFilter(event: MatSelectChange): void {
    this.status = event.value;
    this.load();
    this.paginator.resetFirstPage();
  }

  setCampaignFilter(event: MatSelectChange): void {
    this.campaignId = event.value;
    this.load();
    this.paginator.resetFirstPage();
  }

  pageEvent(event: any): void {
    this.limit = event.pageSize;
    this.page = event.pageIndex;
    this.load();
  }
}
